import ChannelListContainer from 'features/channel-list';
import '../styles/layout/_page.scss';

const ChannelsPage = () => {
  return <ChannelListContainer />;
};
export default ChannelsPage;
